module.exports = __webpack_public_path__ + "img/giraffe.ed1f17a.png";